import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { useSelector } from 'react-redux'
import { Autoplay } from 'swiper/modules'
import { chatListAdsViewer } from '$logic/ads/storage'
import { handleLink } from '$logic/router/url'

export function Ads() {
  const items = useSelector(chatListAdsViewer)

  const show = !!items?.length
  const [clickedBefore, setClickedBefore] = useState<string[]>([])
  const itemsToShow = items.filter(item => !clickedBefore.includes(item.image))

  return show ? (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 10000, disableOnInteraction: true }}
      loop
      onClick={s => {
        const clickedItem = itemsToShow[s.clickedIndex]
        if (!clickedItem) return
        setClickedBefore([...clickedBefore, clickedItem.image])
        const { campaign, link } = clickedItem
        const se = sessionStorage.getItem('locationSearch')
        sessionStorage.setItem(
          'locationSearch',
          se ? `${se}&${campaign}` : campaign,
        )
        analite('CHATLIST_ADS_CLICK', { c: campaign, a: 'c' })
        handleLink(link, { forceJoinChat: true, forceOpenLink: true })
        // handleLink(link, campaign)
      }}
    >
      {itemsToShow.map(({ link, image, campaign }) => (
        <SwiperSlide>
          <img
            style={{
              width: '100%',
              cursor: 'pointer',
              display: 'block',
            }}
            alt={campaign}
            key={link}
            src={image}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  ) : null
}
